import React from "react";

const NotFound = () => {
  return (
    <div className="py-4 m-5">
      <img
        className="img-fluid"
        style={{ width: "50%" }}
        src="https://asia-exstatic.vivo.com/static/img/error/404-PC_31daffa.png"
        alt=""
      />
    </div>
  );
};

export default NotFound;
